"use client";
import styles from "./header.module.scss";
import Image from "next/image";
import { AstroImages } from "../constants";
import { useContext, useState,useEffect,useRef } from "react";
import { AppContext } from "@/context/AppContext";
import { useRouter } from "next/navigation";
import {
  DIAMOND_ICON_PINK,
  RUPEE_PURPLLE_ICON,
  RUPEE_WHITE_ICON,
  DEFAULT_AVATAR
} from "@/utils/imageRelativePaths";
import insufficientBalancePopup from "@/modules/Astro/components/InsufficientBalancePopup";
export default function Header() {
  const router = useRouter();
  const NavLinks = [
    "Home",
    "Horoscope",
    "Connect",
    "Reports",
    "Book a pooja",
    "Shop",
    "Blogs",
  ];
  const [mobileHeader, setMobileHeader] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [imgError, setImgError] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const context = useContext(AppContext);
  const { setPopups, auth, userData } = context ?? {};
  const { token } = auth ?? {};
  
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    setImgError(false);
  }, [userData?.profilePic, token]);
  const handleClickLogin = () => {
    setPopups &&
      setPopups({
        showLoginPopup: true,
      });
  };
  const handleClickLogout = () => {
    setPopups &&
      setPopups({
        logoutPopup: true,
      });
  };
  return (
    <div className={styles["header_cont"]}>
      <div className={styles["logo_cont"]} onClick={() => router.push("/")}>
        <img
          src={
            "https://media.chingari.io/apipublic/chingari-web-assets/images/astro/astro-icon.png"
          }
          alt="Astro"
        />
        <p>ASTROLIVE</p>
      </div>
      <div className={styles["links_cont"]}>
        {[].map((link, index) => (
          <div key={index}>{link}</div>
        ))}
      </div>
      {token ? (
        <div
          className={styles.wallet_diamonds_count}
          onClick={() => router.push("/store")}
        >
          <Image
            src={RUPEE_PURPLLE_ICON}
            alt="dimond-ic"
            height={29}
            width={31}
          />
          <span className={styles.count}>{userData?.diamonds}</span>
        </div>
      ) : (
        ""
      )}
      {token ? (
         <div className={styles.user_menu_container} ref={dropdownRef}>
          <div
            className={styles.avatar_container}
            onClick={() => setIsDropdownOpen((prev) => !prev)}
          >
            {imgError || !userData?.profilePic ? (
              <div className={styles.avatar_initial}>
                {userData?.name
                  ? userData.name.trim().charAt(0).toUpperCase()
                  : userData?.username
                  ? userData.username.trim().charAt(0).toUpperCase()
                  : "U"}
              </div>
            ) : (
              <img
                src={userData.profilePic}
                alt={userData?.name || "User Avatar"}
                className={styles.avatar_img}
                onError={() => setImgError(true)}
              />
            )}
          </div>
          {isDropdownOpen && (
            <div className={styles.dropdown_menu}>
              <div
                className={styles.dropdown_item}
                onClick={() => {
                  router.push("/profile");
                  setIsDropdownOpen(false);
                }}
              >
                Profile Page
              </div>
              <div
                className={`${styles.dropdown_item} ${styles.logout_item}`}
                onClick={() => {
                  handleClickLogout();
                  setIsDropdownOpen(false);
                }}
              >
                Logout
              </div>
            </div>
          )}
        </div>
      ) : (
        <button onClick={handleClickLogin} className={styles["login_btn"]}>
          LOGIN
        </button>
      )}
      <div className={styles["menu_icon_cont"]}>
        <Image
          src={mobileHeader ? AstroImages.CLOSE_ICON : AstroImages.MENU_ICON}
          onClick={() => setMobileHeader((val) => !val)}
          alt={"menu"}
          className={styles["menu_icon"]}
        />
      </div>
      <div
        className={`${styles["mobile_header"]} ${
          mobileHeader ? styles["show_mobile_header"] : ""
        }`}
      >
        <div className={styles["links_cont"]}>
          {NavLinks.map((link, index) => (
            <div className={styles["link"]} key={index}>
              {link}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
